<template>
    <div class="app_list">
        <div class="title">请选择游戏</div>
        <div class="scrollbar content">
            <div v-for="(item,i) in gameList" :key="i" :class="{'app_item':true,'active': app_id == item.id}" @click="chooseGame(item.id,item.app_name,item.icon)">
                <img class="icon" :src="item.icon" alt="">
                <div class="name">{{ item.app_name }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
    
        }
    },
    computed: {
        app_id() {
            return this.$store.state.game_id
        },
        gameList() {
            return this.$store.state.gameList
        }
    },
    mounted() {
 
    },
    methods: {
        chooseGame(name,icon,id) {
            this.$store.commit('setGameInfo', {
                name,
                icon,
                id
            })
            this.$store.commit('setCt','')
            this.$store.commit('setCi','')
            this.$store.commit('setCt2','')
            this.$store.commit('setCi2','')
            this.$parent.handleClose()
        }
    },
}
</script>
<style lang="less" scoped>
    .app_list {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        .title {
            padding: 0.8rem 1.2rem;
            font-size: 1.6rem;
            height: 3.6rem;
        }
        .content {
            flex: 1;
            padding: 1.2rem;
            padding-right: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-content: flex-start;
            .app_item {
                width: 7.8rem;
                padding: 0.5rem 0;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 2rem;
                border-radius: 0.3rem;
                cursor: pointer;
                border: 1px solid transparent;
                .icon {
                    width: 5rem;
                    height: 5rem;
                    border-radius: 0.8rem;
                    margin-bottom: 0.3rem;
                }
                .name {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    font-size: 1.2rem;
                    text-align: center;
                    transform: scale(0.95);
                    transition: center center;
                }
                &:nth-child(3n+2) {
                    margin: 0 2.5rem 2rem;
                }

                &.active{
                    border-color: var(--theme);
                    background-color: var(--themebgc);
                    .name {
                        color: var(--theme);
                    }
                }
                
            }
        }
    }
</style>